import React, { useState, useEffect } from 'react';
import {
  Accordion,
  Card,
  Col,
  Container,
  InputGroup,
  Row,
} from 'react-bootstrap';
import FilterModal from 'src/Admin/components/common/filter-modal/FilterModal';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import {
  AccordionBlueUpArrow,
  CrossDeleteIcon,
  TrashIcon,
} from 'src/Admin/img/findcare/FindCareSVG';
import List from '../List';
import TextInput from 'src/Components/GenericInputText/TextInput';

const ShowSelectedData = ({
  blobData,
  deleteBlob,
  deleteEmployer,
  deleteLocation,
  getEmployerData,
  getLocationData,
  setBlobData,
  dispatch,
}) => {
  const [accordionEventKey, setAsccordionEventKey] = useState('close');
  const [reportsBlobFlow, setReportsBlobFlow] = useState('blob'); //"blob" or "employer" or "location"

  const [employerModalOpen, setEmployerModelOpen] = useState(false);
  const [locationModalOpen, setLocationModelOpen] = useState(false);
  const [searchEmployerText, setSearchEmployerText] = useState('');
  const [searchLocationText, setSearchLocationText] = useState('');
  const [employerDataLocal, setEmployerDataLocal] = useState(blobData);
  const [locationrDataLocal, setLocationDataLocal] = useState(blobData);

  const [employerModalOpenForRange, setEmployerModelOpenForRange] =
    useState(false);
  const [locationModalOpenForRange, setLocationModelOpenForRange] =
    useState(false);
  const [searchEmployerTextFrom, setSearchEmployerTextFrom] = useState('');
  const [searchEmployerTextTo, setSearchEmployerTextTo] = useState('');
  const [searchLocationTextFrom, setSearchLocationTextFrom] = useState('');
  const [searchLocationTextTo, setSearchLocationTextTo] = useState('');

  const selectChangeHandler = (e) => {
    const { name, checked, id } = e.target;
    if (employerModalOpen) {
      const tempBlob = blobData?.allEmployerData?.map((blob) =>
        blob?.ClientId === id
          ? { ...blob, isChecked: true }
          : { ...blob, isChecked: false },
      );
      setEmployerDataLocal({
        ...employerDataLocal,
        allEmployerData: tempBlob,
        selectedEmployerData: tempBlob?.filter(
          (item) => item?.isChecked === true,
        )[0],
      });
    } else if (locationModalOpen) {
      const tempLoc = blobData?.allLocationData?.map((blob) =>
        blob?.LocationName === id
          ? { ...blob, isChecked: true }
          : { ...blob, isChecked: false },
      );
      setLocationDataLocal({
        ...employerDataLocal,
        allLocationData: tempLoc,
        selectedLocationData: tempLoc?.filter(
          (item) => item?.isChecked === true,
        )[0],
      });
    }
  };

  useEffect(() => {
    if (
      blobData?.selectedBlobData?.BlkOfBusId ||
      blobData?.selectedBlobData?.from
    ) {
      setReportsBlobFlow('blob');
    } else if (
      blobData?.selectedEmployerData?.oid ||
      blobData?.selectedEmployerData?.from
    ) {
      setReportsBlobFlow('employer');
    } else if (
      blobData?.selectedLocationData?.oid ||
      blobData?.selectedLocationData?.from
    ) {
      setReportsBlobFlow('location');
    }
  }, []);

  return (
    <div>
      {reportsBlobFlow === 'blob' && (
        <div>
          <div>
            <div className="section-header">
              Block of Business(es)
              <span className="secion-data-count">
                (
                {blobData?.selectedBlobData?.from
                  ? 'Range of Block of Business'
                  : blobData?.selectedBlobData?.oid && '1 Block of Business'}
                )
              </span>
            </div>
            <div className="reports-blob-accordion-container">
              <Accordion>
                <Accordion.Toggle
                  as={Card.Header}
                  className="panel-toggle text-left w-100 bg-white"
                  variant="link"
                  onClick={() =>
                    setAsccordionEventKey(
                      accordionEventKey === 'open' ? 'close' : 'open',
                    )
                  }
                  eventKey="open"
                >
                  <div className="panel-card-header">
                    <div className="d-flex align-items-center">
                      <span className="mb-1">
                        <AccordionBlueUpArrow
                          svgClassName={
                            accordionEventKey === 'open' ? '' : 'down-arrow'
                          }
                          className="acc-arrow"
                        />
                      </span>
                      <span className="blob-name-container">
                        {blobData?.selectedBlobData?.BlkOfBusName ||
                          `Block of Business Range from ${blobData?.selectedBlobData?.from} to ${blobData?.selectedBlobData?.to}`}
                      </span>{' '}
                      <span className="blob-count-container">
                        (
                        {blobData?.selectedEmployerData?.oid
                          ? '1 Employer'
                          : blobData?.selectedEmployerData?.from
                          ? 'Range of Employer'
                          : 'All Employer'}
                        )
                      </span>
                      <div className="selection-controler-container">
                        <div
                          className={
                            blobData?.selectedEmployerData?.oid ||
                            blobData?.selectedEmployerData?.from
                              ? 'first-option-disabled'
                              : 'first-option'
                          }
                          onClick={() => {
                            if (
                              !(
                                blobData?.selectedEmployerData?.oid ||
                                blobData?.selectedEmployerData?.from
                              )
                            ) {
                              getEmployerData();
                              setLocationModelOpen(false);
                              setEmployerModelOpen(true);
                            }
                          }}
                        >
                          Select a Employer by Name or ID
                        </div>
                        {' | '}
                        <div
                          className={
                            blobData?.selectedEmployerData?.oid ||
                            blobData?.selectedEmployerData?.from
                              ? 'second-option-disabled'
                              : 'second-option'
                          }
                          onClick={() => {
                            if (
                              !(
                                blobData?.selectedEmployerData?.oid ||
                                blobData?.selectedEmployerData?.from
                              )
                            ) {
                              setLocationModelOpenForRange(false);
                              setEmployerModelOpenForRange(true);
                            }
                          }}
                        >
                          Select a Range
                        </div>
                        <div>
                          <button
                            type="button"
                            className="trash-button"
                            onClick={() => {
                              deleteBlob();
                            }}
                          >
                            <TrashIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="open">
                  <Card.Body>
                    {(blobData?.selectedEmployerData?.oid ||
                      blobData?.selectedEmployerData?.from) && (
                      <div className="report-accordion-body-section">
                        <div className="d-flex align-items-center">
                          <div className="employer-name-container">
                            {blobData?.selectedEmployerData?.ClientName ||
                              `Employer Range from ${blobData?.selectedEmployerData?.from} to ${blobData?.selectedEmployerData?.to}`}
                            <span className="employer-count-container">
                              (
                              {blobData?.selectedLocationData?.oid
                                ? '1 Location'
                                : blobData?.selectedLocationData?.from
                                ? 'Range of Location'
                                : 'All Locations'}
                              )
                            </span>
                          </div>
                          <div className="selection-controler-container">
                            <div
                              className={
                                blobData?.selectedLocationData?.oid ||
                                blobData?.selectedLocationData?.from
                                  ? 'first-option-disabled'
                                  : 'first-option'
                              }
                              onClick={() => {
                                if (
                                  !(
                                    blobData?.selectedLocationData?.oid ||
                                    blobData?.selectedLocationData?.from
                                  )
                                ) {
                                  getLocationData();
                                  setEmployerModelOpen(false);
                                  setLocationModelOpen(true);
                                }
                              }}
                            >
                              Select a Location by Name or ID
                            </div>
                            {' | '}
                            <div
                              className={
                                blobData?.selectedLocationData?.oid ||
                                blobData?.selectedLocationData?.from
                                  ? 'second-option-disabled'
                                  : 'second-option'
                              }
                              onClick={() => {
                                if (
                                  !(
                                    blobData?.selectedLocationData?.oid ||
                                    blobData?.selectedLocationData?.from
                                  )
                                ) {
                                  setEmployerModelOpenForRange(false);
                                  setLocationModelOpenForRange(true);
                                }
                              }}
                            >
                              Select a Range
                            </div>
                            <div>
                              <button
                                type="button"
                                className="trash-button"
                                onClick={() => {
                                  deleteEmployer();
                                }}
                              >
                                <TrashIcon />
                              </button>
                            </div>
                          </div>
                        </div>
                        {(blobData?.selectedLocationData?.LocationName ||
                          blobData?.selectedLocationData?.from) && (
                          <span className="location">
                            <span className="location-name">
                              {blobData?.selectedLocationData?.LocationName ||
                                `Location Range from ${blobData?.selectedLocationData?.from} to ${blobData?.selectedLocationData?.to}`}
                            </span>
                            {
                              <span
                                className="cross-delete-icon"
                                onClick={() => {
                                  deleteLocation();
                                }}
                              >
                                <CrossDeleteIcon />
                              </span>
                            }
                          </span>
                        )}
                      </div>
                    )}
                  </Card.Body>
                </Accordion.Collapse>
              </Accordion>
            </div>
          </div>
        </div>
      )}
      {reportsBlobFlow === 'employer' && (
        <>
          <div className="section-header">
            Employer(s)
            <span className="secion-data-count">
              (
              {blobData?.selectedEmployerData?.oid
                ? '1 Employer'
                : blobData?.selectedEmployerData?.from
                ? 'Range of Employer'
                : 'All Employers'}
              )
            </span>
          </div>
          <div className="reports-blob-accordion-container p-0 border-0">
            {(blobData?.selectedEmployerData?.oid ||
              blobData?.selectedEmployerData?.from) && (
              <div className="report-accordion-body-section my-2 mx-0">
                <div className="d-flex align-items-center">
                  <div className="employer-name-container">
                    {blobData?.selectedEmployerData?.ClientName ||
                      `Employer Range from ${blobData?.selectedEmployerData?.from} to ${blobData?.selectedEmployerData?.to}`}
                    <span className="employer-count-container">
                      (
                      {blobData?.selectedLocationData?.oid
                        ? '1 Location'
                        : blobData?.selectedLocationData?.from
                        ? 'Range of Location'
                        : 'All Locations'}
                      )
                    </span>
                  </div>
                  <div className="selection-controler-container">
                    <div
                      className={
                        blobData?.selectedLocationData?.oid ||
                        blobData?.selectedLocationData?.from
                          ? 'first-option-disabled'
                          : 'first-option'
                      }
                      onClick={() => {
                        if (
                          !(
                            blobData?.selectedLocationData?.oid ||
                            blobData?.selectedLocationData?.from
                          )
                        ) {
                          getLocationData();
                          setEmployerModelOpen(false);
                          setLocationModelOpen(true);
                        }
                      }}
                    >
                      Select a Location by Name or ID
                    </div>
                    {' | '}
                    <div
                      className={
                        blobData?.selectedLocationData?.oid ||
                        blobData?.selectedLocationData?.from
                          ? 'second-option-disabled'
                          : 'second-option'
                      }
                      onClick={() => {
                        if (
                          !(
                            blobData?.selectedLocationData?.oid ||
                            blobData?.selectedLocationData?.from
                          )
                        ) {
                          setEmployerModelOpenForRange(false);
                          setLocationModelOpenForRange(true);
                        }
                      }}
                    >
                      Select a Range
                    </div>
                    <div>
                      <button
                        type="button"
                        className="trash-button"
                        onClick={() => {
                          deleteEmployer();
                        }}
                      >
                        <TrashIcon />
                      </button>
                    </div>
                  </div>
                </div>
                {(blobData?.selectedLocationData?.LocationName ||
                  blobData?.selectedLocationData?.from) && (
                  <span className="location">
                    <span className="location-name">
                      {blobData?.selectedLocationData?.LocationName ||
                        `Location Range from ${blobData?.selectedLocationData?.from} to ${blobData?.selectedLocationData?.to}`}
                    </span>
                    {
                      <span
                        className="cross-delete-icon"
                        onClick={() => {
                          deleteLocation();
                        }}
                      >
                        <CrossDeleteIcon />
                      </span>
                    }
                  </span>
                )}
              </div>
            )}
          </div>
        </>
      )}
      {reportsBlobFlow === 'location' && (
        <div>
          <div className="section-header">
            Location(s)
            <span className="secion-data-count">
              (
              {blobData?.selectedLocationData?.oid
                ? '1 Location'
                : blobData?.selectedLocationData?.from
                ? 'Range of Location'
                : 'All Locations'}
              )
            </span>
          </div>
          <div className="reports-blob-accordion-container p-0 border-0">
            {(blobData?.selectedLocationData?.oid ||
              blobData?.selectedLocationData?.from) && (
              <div className="report-accordion-body-section my-2 mx-0 p-0 bg-white">
                {(blobData?.selectedLocationData?.LocationName ||
                  blobData?.selectedLocationData?.from) && (
                  <span className="location">
                    <span className="location-name">
                      {blobData?.selectedLocationData?.LocationName ||
                        `Location Range from ${blobData?.selectedLocationData?.from} to ${blobData?.selectedLocationData?.to}`}
                    </span>
                    {
                      <span
                        className="cross-delete-icon"
                        onClick={() => {
                          deleteLocation();
                        }}
                      >
                        <CrossDeleteIcon />
                      </span>
                    }
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      <FilterModal
        showBackButton={false}
        isVisible={employerModalOpen || locationModalOpen}
        onHide={() => {
          setSearchEmployerText('');
          setSearchLocationText('');
          setEmployerModelOpen(false);
          setLocationModelOpen(false);
        }}
        applyFilterHandler={() => {
          if (employerModalOpen) {
            console.log('DataLocal emp', employerDataLocal);
            dispatch(
              setBlobData({
                allEmployerData: employerDataLocal?.allEmployerData,
                selectedEmployerData: employerDataLocal?.selectedEmployerData,
              }),
            );
            setEmployerModelOpen(false);
          }
          if (locationModalOpen) {
            console.log('DataLocal loc', locationrDataLocal);
            dispatch(
              setBlobData({
                allLocationData: locationrDataLocal?.allLocationData,
                selectedLocationData: locationrDataLocal?.selectedLocationData,
              }),
            );
            setLocationModelOpen(false);
          }
        }}
        showCancel={true}
        titleLabel={employerModalOpen ? 'Employer(s)' : 'Location(s)'}
        showApply={true}
        showApplyLabel="Add Selected"
        customClasses="reports-blob-modal"
      >
        <Container className="mt-3 mb-3">
          <Row>
            <Col sm={12}>
              <div>
                <TextInput
                  parentClassName="mb-2"
                  label={employerModalOpen ? 'Employer' : 'Location'}
                  append={
                    <InputGroup.Text>
                      <SearchSVG.SearchSVG className="primary-text-color" />
                    </InputGroup.Text>
                  }
                  inputProps={{
                    type: 'text',
                    placeholder: employerModalOpen
                      ? 'Search by name or Employer ID'
                      : 'Search by name or description',
                    value: employerModalOpen
                      ? searchEmployerText
                      : searchLocationText,
                    onChange: (e) => {
                      if (employerModalOpen) {
                        setSearchEmployerText(e.target.value);
                      } else if (locationModalOpen) {
                        setSearchLocationText(e.target.value);
                      }
                    },
                    className: 'border-right-0',
                    autoFocus: false,
                    id: 'filter-broker-input',
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="mb-1">
              <List
                data={
                  employerModalOpen
                    ? employerDataLocal?.allEmployerData?.length > 0
                      ? employerDataLocal?.allEmployerData
                      : blobData?.allEmployerData
                    : locationModalOpen
                    ? locationrDataLocal?.allLocationData?.length > 0
                      ? locationrDataLocal?.allLocationData
                      : blobData?.allLocationData
                    : []
                }
                selectChangeHandler={selectChangeHandler}
                displayId={employerModalOpen ? 'ClientId' : 'LocationName'}
                displayLabel={employerModalOpen ? 'ClientName' : 'LocationName'}
                labelIdText={employerModalOpen ? 'Employer ID' : 'Client ID'}
                searchString={
                  employerModalOpen ? searchEmployerText : searchLocationText
                }
                modalFor={employerModalOpen ? 'employer' : 'location'}
                fetchData={
                  employerModalOpen ? getEmployerData : getLocationData
                }
                rightValueForLocationDisplayID={
                  locationModalOpen ? 'ClientId' : null
                }
                hasDescriptionText={locationModalOpen}
              />
            </Col>
          </Row>
        </Container>
      </FilterModal>
      <FilterModal
        showBackButton={false}
        isVisible={employerModalOpenForRange || locationModalOpenForRange}
        onHide={() => {
          setSearchEmployerTextFrom('');
          setSearchEmployerTextTo('');
          setEmployerModelOpenForRange(false);

          setSearchLocationTextFrom('');
          setSearchLocationTextTo('');
          setLocationModelOpenForRange(false);
        }}
        applyFilterHandler={() => {
          if (employerModalOpenForRange) {
            dispatch(
              setBlobData({
                allEmployerData: [],
                selectedEmployerData: {
                  from: searchEmployerTextFrom,
                  to: searchEmployerTextTo,
                },
              }),
            );
            setEmployerModelOpenForRange(false);
          } else if (locationModalOpenForRange) {
            dispatch(
              setBlobData({
                allLocationData: [],
                selectedLocationData: {
                  from: searchLocationTextFrom,
                  to: searchLocationTextTo,
                },
              }),
            );
            setLocationModelOpenForRange(false);
          }
        }}
        showCancel={true}
        titleLabel={employerModalOpenForRange ? 'Employer(s)' : 'Location(s)'}
        showApply={true}
        showApplyLabel={'Add Range'}
        customClasses="reports-blob-modal"
      >
        <Container className="mt-3 mb-3">
          <Row>
            <Col sm={12} className="mt-3">
              <div>
                <TextInput
                  parentClassName="mb-2"
                  label={
                    employerModalOpenForRange
                      ? 'From Employer ID'
                      : 'From Location ID'
                  }
                  inputProps={{
                    type: 'text',
                    placeholder: 'Example: 87890',
                    value: employerModalOpenForRange
                      ? searchEmployerTextFrom
                      : searchLocationTextFrom,
                    onChange: (e) => {
                      employerModalOpenForRange
                        ? setSearchEmployerTextFrom(e.target.value)
                        : setSearchLocationTextFrom(e.target.value);
                    },
                    className: 'border-right-0',
                    autoFocus: false,
                    id: 'filter-broker-input',
                  }}
                />
              </div>
            </Col>
            <Col sm={12} className="mt-3">
              <div>
                <TextInput
                  parentClassName="mb-2"
                  label={
                    employerModalOpenForRange
                      ? 'To Employer ID'
                      : 'To Location ID'
                  }
                  inputProps={{
                    type: 'text',
                    placeholder: 'Example: 87890',
                    value: employerModalOpenForRange
                      ? searchEmployerTextTo
                      : searchLocationTextTo,
                    onChange: (e) => {
                      employerModalOpenForRange
                        ? setSearchEmployerTextTo(e.target.value)
                        : setSearchLocationTextTo(e.target.value);
                    },
                    className: 'border-right-0',
                    autoFocus: false,
                    id: 'filter-broker-input',
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </FilterModal>
    </div>
  );
};

export default ShowSelectedData;
